// import main module definition.
import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import App from './App';

import '../../../css/recommendedGames/recommendedGames.scss';
// react version
const recommendedGamesId = 'recommended-games-container';

ready(() => {
  if (document.getElementById(recommendedGamesId)) {
    render(<App />, document.getElementById(recommendedGamesId));
  }
});
